"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSyncValidate = exports.isSyncTransform = void 0;
var isSyncTransform = function isSyncTransform(transform) {
  return transform.length === 1;
};
exports.isSyncTransform = isSyncTransform;
var isSyncValidate = function isSyncValidate(validate) {
  return validate.length === 1;
};
exports.isSyncValidate = isSyncValidate;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3R5cGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFvQk8sSUFBTSxlQUFlLEdBQUcsU0FBbEIsZUFBZSxDQUN4QixTQUFxQyxFQUNBO0VBQ3JDLE9BQU8sU0FBUyxDQUFDLE1BQU0sS0FBSyxDQUFDO0FBQ2pDLENBQUM7QUFKWSx1QkFBZTtBQVlyQixJQUFNLGNBQWMsR0FBRyxTQUFqQixjQUFjLENBQW1CLFFBQXdCLEVBQW9DO0VBQ3RHLE9BQU8sUUFBUSxDQUFDLE1BQU0sS0FBSyxDQUFDO0FBQ2hDLENBQUM7QUFGWSxzQkFBYyIsImlnbm9yZUxpc3QiOltdfQ==